import { useCallback } from 'react'

import axios from 'axios'

import { identifyUser } from '../analytics'
import { permissions } from '../api/auth'
import { useUserContext } from '../contexts/userContext'

export const useHandleDbTokenResponse = () => {
  const { updateUser } = useUserContext()

  return useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper user type
    (user: any) => {
      localStorage.setItem('db_usr', JSON.stringify(user))
      axios.defaults.headers.common['Authorization'] = `Bearer ${user.token}`
      identifyUser(user)
      permissions(user.public_id).then(data => {
        updateUser({
          ...user,
          token: user.token,
          isAuthenticated: true,
          permissions: data.data,
          loading: false,
        })
      })
    },
    [updateUser],
  )
}
